// Gallery photos by season (newest season first).
import G1 from '../pages/Gallery/Image/G1.webp';
import G2 from '../pages/Gallery/Image/G2.webp';
import G3 from '../pages/Gallery/Image/G3.webp';
import G4 from '../pages/Gallery/Image/G4.webp';
import G5 from '../pages/Gallery/Image/G5.webp';
import G6 from '../pages/Gallery/Image/G6.webp';
import G7 from '../pages/Gallery/Image/G7.webp';
import G8 from '../pages/Gallery/Image/G8.webp';
import G9 from '../pages/Gallery/Image/G9.webp';
import G10 from '../pages/Gallery/Image/G10.webp';
import G11 from '../pages/Gallery/Image/G11.webp';
import G12 from '../pages/Gallery/Image/G12.webp';
import G13 from '../pages/Gallery/Image/G13.webp';
import G14 from '../pages/Gallery/Image/G14.webp';
import G15 from '../pages/Gallery/Image/G15.webp';
import G16 from '../pages/Gallery/Image/G16.webp';
import G17 from '../pages/Gallery/Image/G17.webp';
import G18 from '../pages/Gallery/Image/G18.webp';
import G19 from '../pages/Gallery/Image/G19.webp';
import G20 from '../pages/Gallery/Image/G20.webp';
import G21 from '../pages/Gallery/Image/G21.webp';
import G22 from '../pages/Gallery/Image/G22.webp';
import H1 from '../pages/Gallery/Image/H1.webp';
import H2 from '../pages/Gallery/Image/H2.webp';
import H3 from '../pages/Gallery/Image/H3.webp';
import H4 from '../pages/Gallery/Image/H4.webp';
import H5 from '../pages/Gallery/Image/H5.webp';
import H6 from '../pages/Gallery/Image/H6.webp';
import H7 from '../pages/Gallery/Image/H7.webp';
import H8 from '../pages/Gallery/Image/H8.webp';
import H9 from '../pages/Gallery/Image/H9.webp';
import H10 from '../pages/Gallery/Image/H10.webp';
import H11 from '../pages/Gallery/Image/H11.webp';
import H12 from '../pages/Gallery/Image/H12.webp';
import H13 from '../pages/Gallery/Image/H13.webp';
import H14 from '../pages/Gallery/Image/H14.webp';
import H15 from '../pages/Gallery/Image/H15.webp';
import H16 from '../pages/Gallery/Image/H16.webp';
import H17 from '../pages/Gallery/Image/H17.webp';
import H18 from '../pages/Gallery/Image/H18.webp';
import H19 from '../pages/Gallery/Image/H19.webp';
import H20 from '../pages/Gallery/Image/H20.webp';
import H21 from '../pages/Gallery/Image/H21.webp';
import H22 from '../pages/Gallery/Image/H22.webp';
import H23 from '../pages/Gallery/Image/H23.webp';
import H24 from '../pages/Gallery/Image/H24.webp';
import H25 from '../pages/Gallery/Image/H25.webp';

// Home page highlights (6 per season).
export const GALLERY_HIGHLIGHTS = {
  '2025-26': [H1, H2, H3, H4, H5, H8],
  '2024-25': [G14, G7, G6, G4, G5, G10],
};

export const GALLERY_ALL = {
  '2025-26': [
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
    H7,
    H8,
    H9,
    H10,
    H11,
    H12,
    H13,
    H14,
    H15,
    H16,
    H17,
    H18,
    H19,
    H20,
    H21,
    H22,
    H23,
    H24,
    H25,
  ],
  '2024-25': [G14, G7, G3, G2, G4, G1, G6, G5, G8, G9, G10, G11, G12, G13, G15, G16, G17, G18, G19, G20, G22, G21],
};
